module.exports = __webpack_public_path__ + "img/514.7c60da08.png";